"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("swiper/react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var initialCardsInSlide = {
    mobile: 1,
    tablet: 2,
    desktop: 2,
};
var DailySlider = function (_a) {
    var items = _a.items, Card = _a.Card, _b = _a.additionalProps, additionalProps = _b === void 0 ? {} : _b;
    var slider = (0, react_1.useRef)(null);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var cardsInSlide = (0, react_1.useMemo)(function () {
        if (breakpoints.mobile)
            return initialCardsInSlide === null || initialCardsInSlide === void 0 ? void 0 : initialCardsInSlide.mobile;
        if (breakpoints.tablet)
            return initialCardsInSlide === null || initialCardsInSlide === void 0 ? void 0 : initialCardsInSlide.tablet;
        return initialCardsInSlide === null || initialCardsInSlide === void 0 ? void 0 : initialCardsInSlide.desktop;
    }, [breakpoints.mobile, breakpoints.tablet]);
    var slides = (0, apps_shared_1.useGenerateSlideBlocks)({
        cards: items,
        cardsInSlide: cardsInSlide,
        countSlides: items.length / cardsInSlide,
    });
    if (!slides || slides.length <= 0)
        return null;
    if (slides.length === 1 && slides[0].length === 1)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { style: { paddingTop: '5px' } },
                react_1.default.createElement(Card, __assign({}, slides[0][0], additionalProps)))));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                slider.current = swiper;
            }, loop: false, spaceBetween: 100, slidesPerView: 1, pagination: { clickable: true }, autoplay: false }, slides.map(function (itemsForSlide, i) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "dailySlider".concat(i) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.slide, style: {
                    gridTemplateColumns: "repeat(".concat(itemsForSlide.length, ", 1fr)"),
                } }, itemsForSlide.map(function (item, idx) { return (react_1.default.createElement(Card, __assign({ key: "digestAvailablePromo".concat(idx) }, item, additionalProps))); })))); })),
        slides.length > 1 && !breakpoints.mobile && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.arrow, " ").concat(styles_module_scss_1.default.prev), onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); } }),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.arrow, " ").concat(styles_module_scss_1.default.next), onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); } })))));
};
exports.default = react_1.default.memo(DailySlider);
